import PageLayout from "pages/layout/PageLayout"
import ConversationFilter from "./organisms/ConversationFilter"
import { useEffect, useState } from "react"
import { getComponentTypesMiddleware } from "pages/project-component-detail/services"
import { getBuildStatusMiddleware } from "pages/project-component/services/api"
import { ConversationsPageContext } from "./contexts/ConversationsPage.context"
import { ReactComponent as ArrowLeftIcon } from "assets/images/icons/arrow-left.svg"
import { STATUS_BUILD } from "components/Status/types"
import { useFilterConversations } from "./conversations.hook"
import {
  getConversationMessagesMiddleware,
  getCustomStatusesMiddleware,
  getListConversationMiddleware,
  getNotificationConversationMiddleware,
  postNotificationConversationMiddleware,
} from "./conversations.api"
import {
  BuildConversationDetail,
  ConversationMessagesDetail,
  emptyConversationMessagesDetail,
  ParamsBuildConversationProps,
  CustomStatus,
  ConversationDetail,
  emptyConversationDetail,
} from "./conversations.type"
import {
  cloneDeep,
  compact,
  isUndefined,
  orderBy,
  remove,
  toArray,
} from "lodash"
import {
  useBoolean,
  useSearchParams,
  useNumber,
  useString,
  useWindowSize,
} from "helpers/hooks"
import ConversationMessagesColumn from "./organisms/ConversationMessagesColumn"
import { ReactComponent as IconNoResult } from "assets/images/icons/icon no-result.svg"
import Button from "components/Button/Button"
import iconNoData from "assets/images/icons/icon-no-data-component.svg"
import { STATUS_RESPONSE } from "types"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { toast } from "react-toastify"
import { useTippyLayout } from "components/TippyCustomzie"
import { umamiTracking, customLocalStorageHandler } from "helpers/utils"
import { EVENT } from "constants/events"
import ConversationColumn from "./organisms/ConversationColunm"
import NoteColumn from "./organisms/NoteColumn"
import { NAME_LOCALSTORAGE } from "constants/localStorage"
import { Stores, getStoreData } from "services/indexedDB"
import { FileEditorDetail } from "pages/project-component-detail/types"
import {
  encryptionController,
  EncryptionKeys,
} from "controllers/EncryptionController"

import { acceptedSharingConversationMiddleware } from "pages/projects/services/api"
import * as Sentry from "@sentry/react"
import {
  SkeletonConversationCard,
  SkeletonConversationMessage,
} from "./molecules/SkeletonConversation"
import { getUnreadConversationMiddleware } from "pages/auth/services/api"

const Conversations = () => {
  const { storageData, handleSetLocalStorage } = customLocalStorageHandler(
    NAME_LOCALSTORAGE.CONVERSATIONS
  )

  const [listBuilds, setListBuilds] = useState<BuildConversationDetail[]>([])
  const [listConversation, setListConversation] = useState<
    ConversationDetail[]
  >([])
  const [selectedConversation, setSelectedConversation] =
    useState<ConversationDetail>(emptyConversationDetail)
  const showBuildInviteeLayout = useBoolean()
  const showConversationDetailLayout = useBoolean(false)
  const activeIdBuild = useString()
  const [conversationMessages, setConversationMessages] =
    useState<ConversationMessagesDetail>(emptyConversationMessagesDetail)
  const pageHook = useNumber(1)
  const rowsPerPageHook = useNumber(20)
  const isMoreData = useBoolean(true)
  const pageMessageHook = useNumber(1)
  const rowsMessagePerPageHook = useNumber(30)
  const isMoreDataMessage = useBoolean(true)
  const isChangeScrollMessageBottom = useBoolean(true)
  const isNotificationMessage = useBoolean(false)
  const openNotes = useBoolean(false)
  const {
    cpnStatusOptions,
    cpnTypeOptions,
    inputSearch,
    isFilter,
    search,
    isLoading,
    isSearch,
    objSelectStatus,
    objSelectType,
    isShowFavorite,
    selectionRange,
    endDateCreate,
    startDateCreate,
    isCalendarLastUpdate,
    selectionDate,
    dateLastUpdate,
    isApplyFilter,
    setCpnStatusOptions,
    setCpnTypeOptions,
    setObjSelectStatus,
    setObjSelectType,
    onChangeInputSearch,
    onKeyPress,
    onOpenInputSearch,
    onChangeCheckboxFavorite,
    onChangeDate,
    isCalendarRanges,
    onApplySelectionRanges,
    onCancelSelectionRanges,
    onChangeModalSelectRanges,
    onClearInputSelectionRanges,
    onChangeModalDateLastUpdate,
    onChangeDateLastUpdate,
    onApplySelectionDateLastUpdate,
    onCancelSelectionlastUpdate,
    onClearInputSelectionDateLastUpdate,
    handleChangeFilerAll,
    onApplyFilter,
    onOpenModalFiler,
    onClickClearFilterNoResult,
    onRemoveInputSearch,
    rollbackFilter,
    onChangeCheckboxDelete,
    isShowDeleted,
    isShowUnread,
    isShowArchive,
    isShowDraft,
    onChangeCheckBoxArchive,
    onChangeCheckBoxUnread,
    customStatuses,
    setCustomStatuses,
    setObjSelectCustomStatus,
    objSelectCustomStatus,
    groupOtion,
    onChangeGroupOption,
    onChangeCheckBoxDraft,
    filterTab,
    filterOrganization,
  } = useFilterConversations()

  const { isMobile } = useWindowSize()
  const { TippyLayout } = useTippyLayout()
  const isLoadingDefault = useBoolean(true)
  const isSavingNote = useBoolean()
  const { searchParams, setSearchParams } = useSearchParams()
  const { workspaceId, conversationId } = searchParams
  const conversationIdQuery = conversationId
  const organizationIdQuery = workspaceId

  const collapse = useBoolean(false)
  const isWarningEncrypted = useBoolean(false)
  const isConversationUnActive = useBoolean(false)
  const isLoadSkeleton = useBoolean(true)
  const isLoadSkeletonMessage = useBoolean(true)
  const organizationActive = useString("")

  useEffect(() => {
    getDataDefault()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isLoadingDefault.value || !isApplyFilter.value) {
      return
    }
    setConversationMessages(emptyConversationMessagesDetail)
    setSearchParams({ conversationId: undefined, workspaceId: undefined })
    isLoading.setValue(true)
    getListConversation(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isApplyFilter.value])

  useEffect(() => {
    if (isLoadingDefault.value) {
      return
    }
    setConversationMessages(emptyConversationMessagesDetail)
    isLoading.setValue(true)
    getListConversation(true)
    openNotes.setValue(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.value])

  useEffect(() => {
    if (
      isSavingNote.value ||
      isLoadingDefault.value ||
      !conversationIdQuery ||
      !organizationActive.value ||
      (selectedConversation.id === conversationIdQuery &&
        selectedConversation.dbName === organizationIdQuery &&
        !isMobile) ||
      (selectedConversation.id === conversationIdQuery &&
        selectedConversation.dbName === organizationIdQuery &&
        isMobile &&
        !showConversationDetailLayout.value)
    ) {
      return
    }
    showConversationDetailLayout.setValue(true)
    const newListConversation = cloneDeep(listConversation)
    const index = newListConversation.findIndex(
      (el) => el.id === conversationIdQuery && el.dbName === organizationIdQuery
    )
    if (index <= -1) {
      setSearchParams({ idConversation: undefined, workspaceId: undefined })
      return
    }
    const newSelectedConversation = {
      ...newListConversation[index],
      is_read: true,
    }
    newListConversation[index] = newSelectedConversation
    setListConversation(newListConversation)
    setSelectedConversation(newSelectedConversation)
    isLoading.setValue(true)
    if (
      newListConversation[index].project_build_status !== STATUS_BUILD.DELETED
    ) {
      getConversationMessages(
        newListConversation[index].id,
        organizationActive.value,
        true,
        true
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    conversationIdQuery,
    organizationIdQuery,
    showConversationDetailLayout.value,
  ])

  useEffect(() => {
    if (!filterOrganization.value) {
      setCustomStatuses([])
      return
    }
    getCustomStatus(filterOrganization.value)
  }, [filterOrganization.value])

  const changeDataFilter = () => {
    const newTypes = compact(toArray(objSelectType))
    const newStatus = compact(toArray(objSelectStatus))
    const newCustomStatus = compact(toArray(objSelectCustomStatus))
    let newFilter: any = {}
    if (isShowFavorite.value) {
      newFilter.is_favorite = isShowFavorite.value
    }
    if (isShowUnread.value) {
      newFilter.is_unread = isShowUnread.value
    }
    if (isShowArchive) {
      newFilter.is_archive = isShowArchive.value
    }
    if (newTypes.length) {
      newFilter.types = newTypes
    }
    if (newStatus.length) {
      newFilter.statuses = newStatus
    }
    if (newCustomStatus) {
      newFilter.custom_statuses = newCustomStatus
    }
    if (startDateCreate) {
      newFilter.created_from = startDateCreate
    }
    if (endDateCreate) {
      newFilter.created_to = endDateCreate
    }
    if (dateLastUpdate) {
      newFilter.updated_from = dateLastUpdate
      newFilter.updated_to = dateLastUpdate
    }
    if (search.value) {
      newFilter.name = search.value
    }
    if (filterTab.value) {
      newFilter.tab = filterTab.value
    }
    if (filterOrganization.value) {
      newFilter.organization = filterOrganization.value
    }

    if (isShowDeleted.value) {
      newFilter.is_deleted = isShowDeleted.value ? 1 : 0
      delete newFilter.is_unread
      delete newFilter.is_archive
      delete newFilter.is_favorite
      delete newFilter.name
      delete newFilter.statuses
      delete newFilter.types
      delete newFilter.tab
    }
    if (groupOtion.value) {
      newFilter.sorted_by = groupOtion.value
    }
    if (isLoadingDefault.value && conversationIdQuery && organizationIdQuery) {
      newFilter.conversation_id = JSON.stringify({
        conversation_id: conversationIdQuery,
        db_name: organizationIdQuery,
      })
    }

    return {
      newFilter,
    }
  }
  const changeProjectParams = (defaultPage?: number) => {
    const { newFilter } = changeDataFilter()

    const newParams: ParamsBuildConversationProps = {
      page: defaultPage ?? pageHook.value + 1,
      pageSize: rowsPerPageHook.value,
      filter: newFilter,
    }
    return {
      params: newParams,
    }
  }
  const getListConversation = async (loading = false) => {
    try {
      isLoadSkeleton.setValue(true)
      isLoadSkeletonMessage.setValue(true)
      const { params } = changeProjectParams(1)
      let conversations = await getListConversationMiddleware(params)
      isMoreData.setValue(
        conversations.filter((el) => !el.is_hidden).length <
          rowsPerPageHook.value
          ? false
          : true
      )
      if (!conversations.length) {
        setSelectedConversation(emptyConversationDetail)
        setConversationMessages(emptyConversationMessagesDetail)
        setListConversation([])
        setSearchParams({
          conversationId: undefined,
          workspaceId: undefined,
        })
        isLoadSkeleton.setValue(false)
        isLoadSkeletonMessage.setValue(false)
        isApplyFilter.setValue(false)
        return
      }

      const draftAttachmentDB = await getStoreData<{
        id: string
        listFile: FileEditorDetail[]
        text: string
      }>(Stores.Conversations)
      conversations = conversations.map((item) => {
        const draftData = draftAttachmentDB.find(
          (attachment) => item.id === attachment.id
        )
        return {
          ...item,
          draftMessage:
            draftData?.text === "<p><br></p>" ? "" : draftData?.text,
          draftAttachments: draftData?.listFile ? draftData.listFile.length : 0,
        }
      }) as ConversationDetail[]

      if (isShowDraft.value) {
        conversations = conversations.filter(
          (item) => item.draftMessage || item.draftAttachments
        )
      }
      if (!conversations.length) {
        setSelectedConversation(emptyConversationDetail)
        setConversationMessages(emptyConversationMessagesDetail)
        setListConversation([])
        setSearchParams({
          conversationId: undefined,
          workspaceId: undefined,
        })
        isLoadSkeleton.setValue(false)
        isLoadSkeletonMessage.setValue(false)
        isApplyFilter.setValue(false)

        return
      }
      isLoadSkeleton.setValue(false)
      let conversationId = ""
      let organizationId = ""
      let conversarionProjectId = ""

      if (conversationIdQuery && organizationIdQuery) {
        const found = conversations.find(
          (item) =>
            item.id === conversationIdQuery &&
            item.dbName === organizationIdQuery
        )
        if (found) {
          conversarionProjectId = found.project_id
          conversationId = conversationIdQuery
          organizationId = found.dbName || ""
        }
      }
      if (!conversationId || !organizationId) {
        conversationId = conversations[0].id
        organizationId = conversations[0].dbName || ""
        conversarionProjectId = conversations[0].project_id
      }
      if (conversarionProjectId) {
        encryptionController().setCurrentProjectKey(conversarionProjectId)
      }

      const index = conversations.findIndex(
        (el) => el.id === conversationId && el.dbName === organizationId
      )
      const selectedConversation = conversations[index > -1 ? index : 0]
      if (!selectedConversation.is_read) {
        conversations[index > -1 ? index : 0].is_read = true
        setListConversation(conversations)
        setTimeout(() => {
          getUnreadConversationMiddleware(true)
        }, 3000)
      } else {
        setListConversation(conversations)
      }

      setSelectedConversation(selectedConversation)
      organizationActive.setValue(organizationId)
      await getConversationMessages(conversationId, organizationId, true)
      setSearchParams({
        conversationId: conversationId,
        workspaceId: organizationId,
      })
      isApplyFilter.setValue(false)
      if (loading) {
        isLoading.setValue(false)
      }
    } catch (error) {
      console.log(error)
      setListBuilds([])
      if (loading) {
        isLoading.setValue(false)
      }
    }
  }

  const getDataDefault = async () => {
    isLoading.setValue(true)
    try {
      await getTypeComponent()
      await getStatusComponent()
      if (isLoadingDefault.value) {
        await getListConversation(false)
      }
      isLoadingDefault.setValue(false)
    } catch (error) {
      setCpnTypeOptions([])
      setCpnStatusOptions([])
      setCustomStatuses([])
    } finally {
      isLoading.setValue(false)
    }
  }
  const getTypeComponent = async () => {
    const dataCpnTypeRes = await getComponentTypesMiddleware()
    setCpnTypeOptions(dataCpnTypeRes)
  }
  const getStatusComponent = async () => {
    const dataCpnStatusRes = await getBuildStatusMiddleware()
    setCpnStatusOptions(dataCpnStatusRes)
  }
  const getCustomStatus = async (newDbName: string) => {
    const data = await getCustomStatusesMiddleware(newDbName)
    setCustomStatuses(data.statuses)
  }
  const updateDataWhenChangeFavorite = (dataRes: ConversationDetail) => {
    const newListConversation = cloneDeep(listConversation)
    const index = newListConversation.findIndex(
      (el) => el.id === dataRes.id && el.dbName === dataRes.dbName
    )
    if (index < 0) {
      return
    }
    if (isShowFavorite.value) {
      if (dataRes.is_favorite) {
        remove(
          newListConversation,
          (el) => el.id === dataRes.id && el.dbName === dataRes.dbName
        )
        if (dataRes.id === selectedConversation.id) {
          setConversationMessages(emptyConversationMessagesDetail)
          setSelectedConversation(emptyConversationDetail)
        }
      }
    } else {
      dataRes.is_favorite = !dataRes.is_favorite
      newListConversation[index] = dataRes
    }
    setListConversation(newListConversation)
  }
  const updateDataWhenArchive = (dataRes: ConversationDetail) => {
    const newListConversation = cloneDeep(listConversation)
    const index = newListConversation.findIndex(
      (el) => el.id === dataRes.id && el.dbName === dataRes.dbName
    )
    if (!isShowArchive.value && dataRes.is_archived_by_me) {
      remove(newListConversation, (el) => el.id === dataRes.id)
      if (dataRes.id === selectedConversation.id) {
        setConversationMessages(emptyConversationMessagesDetail)
        setSelectedConversation(emptyConversationDetail)
      }
    } else {
      newListConversation[index] = dataRes
      if (dataRes.id === selectedConversation.id) {
        setSelectedConversation(newListConversation[index])
      }
    }
    setListConversation(newListConversation)
  }
  const updateDataWhenChangeCustomStatus = (
    type: "edit" | "delete",
    customStatus: CustomStatus
  ) => {
    const newListConversation = cloneDeep(listConversation)
    newListConversation.forEach((conversation) => {
      if (conversation.custom_status?.id === customStatus.id) {
        conversation.custom_status = undefined
        if (type === "edit") {
          conversation.custom_status = customStatus
        }
      }
    })
    setListConversation(newListConversation)
  }
  const updateDataWhenChangeConvoCustomStatus = (
    conversationId: string,
    customStatus?: CustomStatus
  ) => {
    const newListConversation = cloneDeep(listConversation)
    const index = newListConversation.findIndex(
      (el) => el.id === conversationId
    )
    if (index < 0) {
      return
    }
    if (newListConversation[index].custom_status?.id === customStatus?.id) {
      return
    }
    newListConversation[index].custom_status = customStatus
    setListConversation(newListConversation)
  }
  const onClickConversation = (newItem: ConversationDetail) => () => {
    if (
      newItem.id === conversationIdQuery &&
      newItem.dbName === organizationIdQuery
    ) {
      if (isMobile) {
        isLoadSkeletonMessage.setValue(true)
        showConversationDetailLayout.setValue(true)
      }
      return
    }
    setSearchParams({
      conversationId: newItem.id,
      workspaceId: newItem.dbName,
    })
    organizationActive.setValue(newItem.dbName)
    isLoadSkeletonMessage.setValue(true)
    encryptionController().setCurrentProjectKey(newItem.project_id)
    if (!newItem.is_read) {
      setTimeout(() => {
        getUnreadConversationMiddleware(true)
      }, 3000)
    }
  }

  const updateWhenAddMessager = async (newMessage: string) => {
    const newConversationList = cloneDeep(listConversation)
    const index = newConversationList.findIndex(
      (el) =>
        el.id === selectedConversation.id &&
        el.dbName === selectedConversation.dbName
    )
    if (index > -1) {
      newConversationList[index].message = {
        content: newMessage,
        created_at: new Date().toISOString(),
        owner: "",
      }
      newConversationList[index].draftAttachments = 0
      newConversationList[index].draftMessage = ""
      newConversationList[index].updated_at = new Date().toISOString()
      selectedConversation.updated_at = new Date().toISOString()
      await getConversationMessages(
        selectedConversation.id,
        organizationActive.value,
        true,
        true
      )
      setSelectedConversation({ ...selectedConversation })
      setListConversation(newConversationList)
    }
  }
  const getConversationMessages = async (
    conversationId: string,
    newDBKey: string,
    setConversation = false,
    loading = false
  ) => {
    const params = {
      page: 1,
      pageSize: rowsMessagePerPageHook.value,
    }
    const dataRes = await getConversationMessagesMiddleware(
      conversationId,
      newDBKey,
      params
    )
    const isWarningEncrypted = setWarningEncrypted(
      dataRes.conversation_code || "",
      conversationId
    )

    if (!dataRes.invitee.accepted && !dataRes.is_owner && !isWarningEncrypted) {
      await acceptedSharingConversationMiddleware(conversationId)
    }
    await getNotificationConversation(conversationId, newDBKey)
    isConversationUnActive.setValue(dataRes.is_conversation_un_active || false)

    setConversationMessages({
      ...dataRes,
      components: dataRes.components,
      messages: orderBy(dataRes.messages as any, "created_at", "asc"),
    })
    isLoadSkeletonMessage.setValue(false)
    isMoreDataMessage.setValue(
      dataRes.messages.length < rowsMessagePerPageHook.value ? false : true
    )
    pageMessageHook.setValue(1)
    isChangeScrollMessageBottom.setValue(true)
    if (setConversation) {
      handleUpdateConversationCookies(conversationId)
    }
    if (loading) {
      isLoading.setValue(false)
    }
  }

  const setWarningEncrypted = (
    conversationCode: string,
    conversationId: string
  ) => {
    const conversationEncryptionKeys = JSON.parse(
      localStorage.getItem(EncryptionKeys.conversationEncryptionKeys) || "{}"
    )
    if (
      !conversationEncryptionKeys[conversationId] ||
      conversationEncryptionKeys[conversationId].length !== 64
    ) {
      const messageSentry = `This conversation ID: ${conversationCode} is encrypted: ${conversationId}`
      Sentry.captureMessage(messageSentry, {
        level: "warning",
      })
      isWarningEncrypted.setValue(true)
      return true
    }
    isWarningEncrypted.setValue(false)
    return false
  }
  const getNotificationConversation = async (
    conversationId: string,
    dbKey: string
  ) => {
    const dataRes = await getNotificationConversationMiddleware(
      conversationId,
      dbKey
    )
    isNotificationMessage.setValue(dataRes.is_notified)
  }

  const checkShowButtonClearFilter = () => {
    if (isFilter.value) {
      return false
    }
    if (
      isShowFavorite.value ||
      isShowDeleted.value ||
      isShowUnread.value ||
      isShowArchive.value ||
      isShowDraft.value ||
      compact(toArray(objSelectStatus)).length ||
      compact(toArray(objSelectType)).length ||
      compact(toArray(objSelectCustomStatus)).length ||
      startDateCreate ||
      endDateCreate ||
      dateLastUpdate ||
      filterOrganization.value ||
      (filterTab.value && filterTab.value !== "all") ||
      (groupOtion.value && groupOtion.value !== "latest_message")
    ) {
      return true
    }
    return false
  }
  const handleUpdateConversationCookies = (conversationId: string) => {
    const newCookies = !isUndefined(storageData) ? cloneDeep(storageData) : {}
    newCookies.conversationId = conversationId
    handleSetLocalStorage(newCookies)
  }
  const handleLoadMoreConversation = async () => {
    if (!isMoreData.value || !listConversation.length || isLoading.value) {
      return
    }
    isLoading.setValue(true)
    try {
      const { params } = changeProjectParams()

      const dataRes = await getListConversationMiddleware(params)
      isMoreData.setValue(
        dataRes.filter((el) => !el.is_hidden).length < rowsPerPageHook.value
          ? false
          : true
      )
      pageHook.setValue(pageHook.value + 1)
      const newData = cloneDeep(listConversation).concat(dataRes)
      setListConversation(newData)
      isLoading.setValue(false)
    } catch (error) {
      isLoading.setValue(false)
    }
  }
  const onChangeNotification = (originNotification: boolean) => () => {
    if (!selectedConversation.id && selectedConversation.is_archived_by_owner) {
      return
    }
    if (isNotificationMessage.value) {
      umamiTracking(EVENT.CONVERSATION.DISABLE)
    } else {
      umamiTracking(EVENT.CONVERSATION.ENABLE)
    }
    isNotificationMessage.setValue(!originNotification)
    postNotificationConversationMiddleware(
      selectedConversation.id,
      isNotificationMessage.value ? "off" : "on",
      (type: STATUS_RESPONSE, messenger: string) => {
        toast(<LabelNotificationPage messenger={messenger} type={type} />)
        if (type === STATUS_RESPONSE.ERROR) {
          isNotificationMessage.setValue(originNotification)
        }
      }
    )
  }
  const updateCurrentConvoInConvoList = (
    conversationId: string,
    data: Partial<ConversationDetail>
  ) => {
    const newConversationList = cloneDeep(listConversation)
    const currentConvoIndex = newConversationList.findIndex(
      (item) => item.id === conversationId
    )
    if (currentConvoIndex > -1) {
      const newData = {
        ...newConversationList[currentConvoIndex],
        ...data,
      }
      newConversationList[currentConvoIndex] = newData
      setListConversation(newConversationList)
    }
  }
  const renderConversationDetail = () => {
    if (isLoadSkeletonMessage.value) {
      return <SkeletonConversationMessage isMobile={isMobile} />
    }
    if (selectedConversation.project_build_status === STATUS_BUILD.DELETED) {
      return (
        <div className="flex flex-1 flex-col h-full overflow-hidden">
          <div
            className="flex md:hidden p-6"
            onClick={() => {
              showConversationDetailLayout.setValue(false)
            }}
          >
            <ArrowLeftIcon />
          </div>
          <div className="bg-white flex flex-1 items-center justify-center">
            <div className="m-6 flex justify-center flex-col">
              <img src={iconNoData} alt="icon" />
              <p className="text-center font-semibold text-[#111111] text-[16px] leading-[26px] mt-6">
                The conversation is no longer exists.
                <br />
                Please contact project owner.
              </p>
            </div>
          </div>
        </div>
      )
    }

    if (selectedConversation.id) {
      return (
        <ConversationMessagesColumn
          conversationInfo={selectedConversation}
          closeLayout={showConversationDetailLayout}
          conversationMessages={conversationMessages}
          activeIdConversation={selectedConversation.id}
          activeIdBuild={activeIdBuild.value}
          updateWhenAddMessager={updateWhenAddMessager}
          isChangeScrollMessageBottom={isChangeScrollMessageBottom}
          isNotificationMessage={isNotificationMessage.value}
          onChangeNotification={onChangeNotification}
          isConversationUnActive={isConversationUnActive.value}
          getConversationMessages={getConversationMessages}
          collapse={collapse}
          isWarningEncrypted={isWarningEncrypted.value}
          isMoreDataMessage={isMoreDataMessage}
          rowsMessagePerPageHook={rowsMessagePerPageHook}
          selectedConversation={selectedConversation}
          pageMessageHook={pageMessageHook}
          setConversationMessages={setConversationMessages}
          organizationActive={organizationActive}
        />
      )
    }

    return (
      <div className="flex flex-1 flex-col h-full overflow-hidden">
        <div
          className="flex md:hidden p-6"
          onClick={() => {
            showConversationDetailLayout.setValue(false)
          }}
        >
          <ArrowLeftIcon />
        </div>
        <div className="bg-white flex flex-1 items-center justify-center">
          <div className="m-6">
            <img src={iconNoData} alt="icon" />
            <p className="font-semibold text-[#111111] text-[16px] leading-[26px] mt-6">
              No conversation selected!
            </p>
          </div>
        </div>
      </div>
    )
  }

  const renderConversations = () => {
    return (
      <ConversationColumn
        listConversation={listConversation}
        updateDataWhenChangeFavorite={updateDataWhenChangeFavorite}
        updateDataWhenArchive={updateDataWhenArchive}
        onClickConversation={onClickConversation}
        activeConversationId={selectedConversation.id}
        showLayout={showBuildInviteeLayout}
        updateDataWhenChangeCustomStatus={updateDataWhenChangeCustomStatus}
        updateDataWhenChangeConvoCustomStatus={
          updateDataWhenChangeConvoCustomStatus
        }
        openNotes={openNotes}
        groupOtion={groupOtion.value}
        isMoreData={isMoreData.value}
        handleLoadMore={handleLoadMoreConversation}
        isMoreDataLoading={isLoading.value}
        showEditStatus={filterOrganization.value}
      />
    )
  }

  const renderListConversations = () => {
    if (isLoadSkeleton.value) {
      return <SkeletonConversationCard />
    }
    if (listConversation.length) {
      return (
        <div className="flex flex-col h-full overflow-auto">
          {isMobile ? (
            <TippyLayout
              type="content-screen"
              visible={showConversationDetailLayout.value || openNotes.value}
              mainContent={
                openNotes.value
                  ? renderNotesEditor()
                  : showConversationDetailLayout.value
                  ? renderConversationDetail()
                  : null
              }
              containerClass="build-conversation"
            >
              {renderConversations()}
            </TippyLayout>
          ) : (
            renderConversations()
          )}
        </div>
      )
    }

    return (
      <div className="h-full flex flex-col items-center justify-center">
        <IconNoResult style={{ height: 190 }} />
        <p
          className="font-semibold text-16 leading-26  mt-3"
          style={{
            color: "#111111",
          }}
        >
          {checkShowButtonClearFilter()
            ? "No result found!"
            : "No conversations found!"}
        </p>
        {checkShowButtonClearFilter() ? (
          <Button
            title="Clear filter"
            colorBtn="white"
            onClick={onClickClearFilterNoResult}
            sizeBtn="small"
            styleButton={{
              marginTop: 12,
            }}
          />
        ) : null}
      </div>
    )
  }
  const renderNotesEditor = () => {
    if (!selectedConversation.id) {
      return
    }
    return (
      <NoteColumn
        key={selectedConversation.id}
        activeConversationId={selectedConversation.id}
        closeNote={() => {
          showConversationDetailLayout.setValue(false)
          openNotes.setValue(false)
        }}
        isSavingNote={isSavingNote}
      />
    )
  }
  return (
    <PageLayout heightHeader={0} minWidth="min-w-[1280px]">
      <ConversationsPageContext.Provider
        value={{
          cpnStatusOptions,
          cpnTypeOptions,
          objSelectType,
          objSelectStatus,
          setObjSelectType,
          setObjSelectStatus,
          customStatuses,
          setCustomStatuses,
          objSelectCustomStatus,
          setObjSelectCustomStatus,
          updateCurrentConvoInConvoList,
        }}
      >
        <div className="flex h-full">
          <div
            className={`w-full flex transition-all duration-500
            ${
              collapse.value
                ? "md:min-w-0 md:w-0 md:translate-x-[-100%]"
                : "md:min-w-[342px] md:w-[342px]"
            }
            `}
          >
            <div
              className={`flex flex-col flex-1 pl-6 ${
                collapse.value ? "md:pl-0" : ""
              } pt-6 overflow-hidden w-full md:w-[50%]`}
            >
              <ConversationFilter
                isSearch={isSearch.value}
                inputSearch={inputSearch.value}
                onChangeInputSearch={onChangeInputSearch}
                onKeyPress={onKeyPress}
                isFilter={isFilter.value}
                setIsFilter={isFilter.setValue}
                onOpenInputSearch={onOpenInputSearch}
                isShowFavorite={isShowFavorite.value}
                onChangeCheckboxFavorite={onChangeCheckboxFavorite}
                onChangeCheckboxDelete={onChangeCheckboxDelete}
                isShowDeleted={isShowDeleted.value}
                isShowDraft={isShowDraft.value}
                onChangeCheckBoxDraft={onChangeCheckBoxDraft}
                selectionRange={selectionRange}
                onChangeDate={onChangeDate}
                isCalendarRanges={isCalendarRanges.value}
                onApplySelectionRanges={onApplySelectionRanges}
                onCancelSelectionRanges={onCancelSelectionRanges}
                onChangeModalSelectRanges={onChangeModalSelectRanges}
                endDateCreate={endDateCreate}
                startDateCreate={startDateCreate}
                onClearInputSelectionRanges={onClearInputSelectionRanges}
                isCalendarLastUpdate={isCalendarLastUpdate.value}
                selectionDate={selectionDate}
                onChangeModalDateLastUpdate={onChangeModalDateLastUpdate}
                onChangeDateLastUpdate={onChangeDateLastUpdate}
                onApplySelectionDateLastUpdate={onApplySelectionDateLastUpdate}
                onCancelSelectionlastUpdate={onCancelSelectionlastUpdate}
                onClearInputSelectionDateLastUpdate={
                  onClearInputSelectionDateLastUpdate
                }
                dateLastUpdate={dateLastUpdate}
                handleChangeFilerAll={handleChangeFilerAll}
                onApplyFilter={onApplyFilter}
                onOpenModalFiler={onOpenModalFiler}
                isActiveIconFilter={checkShowButtonClearFilter()}
                onRemoveInputSearch={onRemoveInputSearch}
                rollbackFilter={rollbackFilter}
                onChangeCheckBoxUnread={onChangeCheckBoxUnread}
                isShowUnread={isShowUnread.value}
                isShowArchive={isShowArchive.value}
                onChangeCheckBoxArchive={onChangeCheckBoxArchive}
                unreadByFilter={
                  listBuilds.filter((item) => !item.is_read).length
                }
                onChangeGroupOption={onChangeGroupOption}
                groupOption={groupOtion.value}
                organizationActive={organizationActive}
                filterTab={filterTab}
                filterOrganization={filterOrganization}
              />
              {renderListConversations()}
            </div>
          </div>
          <div className="hidden md:flex w-full min-w-[50%]">
            {openNotes.value ? renderNotesEditor() : renderConversationDetail()}
          </div>
        </div>
      </ConversationsPageContext.Provider>
    </PageLayout>
  )
}
export default Conversations
